var map = {
	"./air_horn.mp3": "OtfI",
	"./alien.mp3": "JXeb",
	"./alien_pluck.mp3": "fkgu",
	"./bells.mp3": "9nKn",
	"./crystal.mp3": "QIdb",
	"./desk_rings.mp3": "ZPwz",
	"./digital_alarm.mp3": "gHaa",
	"./drop.mp3": "37Wy",
	"./extreme.mp3": "FwCL",
	"./gas_bell.mp3": "33ib",
	"./laser.mp3": "NapY",
	"./laser_reverse.mp3": "X1+w",
	"./pluck.mp3": "MbY0",
	"./reflect.mp3": "rIk/",
	"./repeat.mp3": "9oJN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xRbD";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound ^\.\/.*\.mp3$
// module id = xRbD
// module chunks = 74